import { HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { CacheInput } from '@api/interceptors';

export enum RequestMethod {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  DELETE = 'delete',
}

export interface HttpOptions {
  headers?: HttpHeaders;
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json' | 'text';
  withCredentials?: boolean;
  context?: HttpContext;
}

interface CustomRequestCommon {
  url?: string;
  externalUrl?: string;
  cache?: CacheInput;
  options?: HttpOptions;
}

interface CustomRequestPOST extends CustomRequestCommon {
  method: 'POST';
  body?: unknown;
  query?: never;
}

interface CustomRequestPATCH extends CustomRequestCommon {
  method: 'PATCH';
  body?: unknown;
  query?: never;
}

interface CustomRequestPUT extends CustomRequestCommon {
  method: 'PUT';
  body?: unknown;
  query?: never;
}

interface CustomRequestDELETE extends CustomRequestCommon {
  method: 'DELETE';
  body?: never;
  query?: never;
}

interface CustomRequestGET extends CustomRequestCommon {
  method: 'GET';
  body?: never;
  query?: Record<string, string>;
}

export type CustomRequest =
  | CustomRequestPOST
  | CustomRequestGET
  | CustomRequestPATCH
  | CustomRequestPUT
  | CustomRequestDELETE;
